import FooterCalloutRepository from "../FooterCalloutRepository"

export default class ContactFooterCallout extends FooterCalloutRepository {
    static schemaId = "contact_us_footerCallout"

    constructor() {
        super(ContactFooterCallout.schemaId)
    }
}
